import { toast } from 'react-toastify';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

/**
 * Litmus Edge — OAuth2 client_credentials.
 * Obtains an app token via backend and returns it for ConnectorToken to persist.
 */
export const getLitmusCredentialsAndCreateToken = async (connectorId, mcId, masterConnectors = []) => {
  if (!API_BASE) throw new Error('REACT_APP_BACKEND_URL is not set');
  if (!mcId) throw new Error('Missing Master Connector ID (mcId)');
  if (!connectorId) throw new Error('Missing Sync Connector ID (connectorId)');

  if (Array.isArray(masterConnectors) && masterConnectors.length > 0) {
    const litmusMc = masterConnectors.find(
      (mc) =>
        (mc.mcRecId?.toString() === mcId?.toString() || mc.mcId?.toString() === mcId?.toString()) &&
        (mc.mcName === 'Litmus' ||
          mc.mcConnectorType === 'LITMUS' ||
          (mc.mcName && mc.mcName.toLowerCase().includes('litmus')))
    );
    if (!litmusMc) {
      throw new Error('Litmus master connector not found');
    }
  }

  const response = await fetch(`${API_BASE}synctrack/litmus/validToken`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
    body: JSON.stringify({
      ctdId: connectorId.toString(),
      forceNew: true,
    }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    let message = `HTTP error! status: ${response.status}`;
    try {
      const errJson = JSON.parse(errorText);
      message = errJson.message || errJson.error || message;
    } catch {
      if (errorText) message = errorText;
    }
    toast.error(`Litmus connect failed: ${message}`);
    throw new Error(message);
  }

  const tokenData = await response.json();
  if (!tokenData?.access_token) {
    throw new Error('Litmus token response missing access_token');
  }

  return tokenData;
};
